import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { putMapStoreNotification } from '../../../services/StoreNotification/StoreNotification';

const StoreNotificationStatusChange = ({ status, editData, sendDataToStoreConfig, brandId }) => {
  const [statusValue, setStatusValue] = useState(status === true);

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    const updatedData = {
      status: newStatus ,
      id: editData.id,
    };

    putMapStoreNotification(updatedData)
      .then((response) => {
        if (!response.data.error) {
          sendDataToStoreConfig({
            success: true,
          });
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  };

  return (
    <div style={{ margin: '10px 0 10px 5px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: '15px',
          width: '100%',
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default StoreNotificationStatusChange;
